
import { Injectable } from '@angular/core';
import { FormBuilder, Validators, AbstractControlOptions, FormGroup } from '@angular/forms';
import { InputValidationService } from '../helpers/validators/input-validation.service';
import { RegExValidation } from '../helpers/constants/regex-validation.constants';

@Injectable({
  providedIn: 'root'
})
export class RegisterFormService {

  constructor(private readonly formBuilder: FormBuilder) {}

  buildRegisterForm(options: { includeIntermediaryCode?: boolean } = {}): FormGroup {
    return this.formBuilder.group({
      FirstName: ['', Validators.required],
      Surname: ['', Validators.required],
      PhoneNumber: ['', [Validators.required, Validators.minLength(10), InputValidationService.isValidMobile]],
      Email: ['', [Validators.required, Validators.email, InputValidationService.isValidEmail]],
      IdNumber: ['', [Validators.required, Validators.minLength(13), InputValidationService.isValidIdNumber]],
      Password: ['', [Validators.required, Validators.minLength(8), Validators.pattern(RegExValidation.password)]],
      ConfirmPassword: ['', Validators.required],
      FinancialPlannerCode: ['', [Validators.minLength(8)]],
      WebSource: '',
      Params: '',
      RegistrationSource: '',
      AcceptTerms: [false, Validators.pattern('true')],
      ...(options.includeIntermediaryCode ? { IntermediaryCodeGuidId: '' } : {})
    }, {
      validator: [
        InputValidationService.passwordMustMatch('Password', 'ConfirmPassword'),
      ],
    } as AbstractControlOptions);
  }
}